import React from "react";

export const AGBPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative py-24 md:py-32 pt-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 -left-20 w-96 h-96 bg-gradient-to-r from-purple-600/30 to-orange-500/30 rounded-full blur-3xl animate-float" />
          <div
            className="absolute bottom-1/4 -right-20 w-80 h-80 bg-gradient-to-r from-orange-500/30 to-purple-600/30 rounded-full blur-3xl animate-float"
            style={{ animationDelay: "-3s" }}
          />
        </div>

        <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-6">
            Allgemeine Geschäftsbedingungen{" "}
            <span className="gradient-text font-medium">(AGB)</span>
          </h1>
          <p className="text-base md:text-lg text-slate-200 max-w-3xl mx-auto leading-relaxed font-light">
            für Beratungs-, Coaching- und Transformationsleistungen von{" "}
            <strong>[FIRMENNAME / MARKE]</strong>
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 space-y-10 text-slate-800 text-sm md:text-base leading-relaxed">
          <p className="text-xs text-slate-500">
            Stand: <strong>[DATUM]</strong> &mdash; Diese AGB richten sich ausschließlich
            an Unternehmer im Sinne von § 14 BGB.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            1. Geltungsbereich und Vertragsparteien
          </h2>
          <p>
            (1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge
            zwischen <strong>[FIRMENNAME]</strong>, vertreten durch{" "}
            <strong>[INHABER:IN / GESCHÄFTSFÜHRUNG]</strong>,{" "}
            <strong>[ANSCHRIFT]</strong> (nachfolgend „Beraterin“ oder „wir“), und
            ihren Auftraggebern (nachfolgend „Kunde“ oder „Auftraggeber“).
          </p>
          <p>
            (2) Unsere Leistungen richten sich ausschließlich an Unternehmer,
            juristische Personen des öffentlichen Rechts oder öffentlich-rechtliche
            Sondervermögen im Sinne von § 14 BGB. Verträge mit
            Verbrauchern (§ 13 BGB) werden nicht geschlossen.
          </p>
          <p>
            (3) Abweichende, entgegenstehende oder ergänzende Allgemeine
            Geschäftsbedingungen des Kunden werden nur Vertragsbestandteil, wenn
            wir ihrer Geltung ausdrücklich schriftlich zustimmen.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            2. Leistungsgegenstand
          </h2>
          <p>
            (1) Wir erbringen Beratungs-, Coaching-, Trainings- und
            Transformationsleistungen, insbesondere in den Bereichen
            Organisationsentwicklung, interkulturelle Zusammenarbeit, Leadership,
            Executive Sparring, TRIAX®-basierte Transformationsbegleitung sowie
            maßgeschneiderte Signature-Programme und SOS-Unterstützung
            (nachfolgend zusammen „Leistungen“).
          </p>
          <p>
            (2) Art, Umfang, Dauer und Zielsetzung der Leistungen ergeben sich aus
            dem jeweiligen Angebot, der Auftragsbestätigung oder einem separaten
            Leistungsdokument (z. B. Scope / Proposal).
          </p>
          <p>
            (3) Wir schulden grundsätzlich eine professionelle, nach anerkannten
            Standards ausgerichtete Dienstleistung, jedoch keinen bestimmten
            wirtschaftlichen Erfolg. Entscheidungen und deren Umsetzung liegen
            ausschließlich in der Verantwortung des Kunden.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            3. Vertragsschluss
          </h2>
          <p>
            (1) Unsere Angebote sind freibleibend und unverbindlich, sofern sie
            nicht ausdrücklich als verbindlich gekennzeichnet sind.
          </p>
          <p>
            (2) Ein Vertrag kommt zustande durch:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              die schriftliche oder elektronische Annahme unseres Angebots durch
              den Kunden (z. B. E-Mail), oder
            </li>
            <li>
              die beidseitige Unterzeichnung eines Beratungs- oder
              Coachingvertrags, oder
            </li>
            <li>
              die Bestätigung einer von uns zugesandten Auftragsbestätigung durch
              den Kunden.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            4. Mitwirkungspflichten des Kunden
          </h2>
          <p>
            (1) Der Kunde stellt alle für die Leistungserbringung erforderlichen
            Informationen, Unterlagen, Zugänge und Entscheidungsträger rechtzeitig
            und vollständig zur Verfügung.
          </p>
          <p>
            (2) Der Kunde sorgt dafür, dass seine Mitarbeitenden und sonstige
            Beteiligte, die für das Projekt relevant sind, in angemessenem Umfang
            verfügbar sind und aktiv mitwirken.
          </p>
          <p>
            (3) Verzögert sich die Leistungserbringung aufgrund fehlender oder
            unvollständiger Mitwirkung des Kunden, verlängern sich Fristen und
            verschieben sich vereinbarte Termine angemessen. Hierdurch entstehende
            Mehraufwände können gesondert in Rechnung gestellt werden.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            5. Vergütung und Zahlungsbedingungen
          </h2>
          <p>
            (1) Unsere Leistungen werden auf Basis des im Angebot genannten
            Honorars oder Tagessatzes bzw. Programmpreises vergütet. Alle
            Beträge verstehen sich netto in Euro zuzüglich der jeweils
            geltenden gesetzlichen Umsatzsteuer.
          </p>
          <p>
            (2) Sofern im Angebot nicht anders geregelt, gilt:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Bei Programmen (z. B. Signature-Programme, längerfristige
              Transformationsprojekte) ist eine Anzahlung in Höhe von{" "}
              <strong>[ANZAHLUNG IN %]</strong>% des Gesamtvolumens bei
              Vertragsschluss fällig.
            </li>
            <li>
              Der Restbetrag ist spätestens <strong>[ANZAHL TAGE]</strong> Tage
              vor Beginn des ersten vereinbarten Moduls / Termins fällig.
            </li>
            <li>
              Bei Einzelsessions / Executive Coachings können abweichende
              Zahlungsmodalitäten vereinbart werden.
            </li>
          </ul>
          <p>
            (3) Rechnungen sind innerhalb von{" "}
            <strong>[ZAHLUNGSZIEL, Z. B. 14]</strong> Tagen nach Rechnungsdatum
            ohne Abzug fällig, sofern nichts anderes vereinbart wurde.
          </p>
          <p>
            (4) Bei Zahlungsverzug sind wir berechtigt, Verzugszinsen in
            gesetzlicher Höhe (§ 288 BGB) zu verlangen und Leistungen bis zum
            vollständigen Ausgleich offener Forderungen zurückzuhalten.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            6. Terminverschiebung, Stornierung und No-Show
          </h2>
          <p>
            (1) Der Kunde kann bestätigte Termine (Workshops, Coachings, Online-
            Sessions, Präsenztermine) nur nach Maßgabe der folgenden Regelungen
            verschieben oder stornieren:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Bis <strong>[X]</strong> Kalendertage vor dem Termin: kostenfreie
              Umbuchung oder Stornierung möglich.
            </li>
            <li>
              Zwischen <strong>[X]</strong> und <strong>[Y]</strong> Kalendertagen
              vor dem Termin: Stornogebühr in Höhe von{" "}
              <strong>[STORNO IN %]</strong>% des vereinbarten Honorars.
            </li>
            <li>
              Weniger als <strong>[Y]</strong> Kalendertage vor dem Termin oder
              bei Nichterscheinen („No-Show“): 100 % des vereinbarten Honorars
              werden fällig.
            </li>
          </ul>
          <p>
            (2) Bereits angefallene, nachweisbare Reise- und
            Vorbereitungskosten sind vom Kunden im Falle einer Stornierung
            vollständig zu tragen.
          </p>
          <p>
            (3) Dem Kunden bleibt der Nachweis vorbehalten, dass kein oder ein
            wesentlich geringerer Schaden entstanden ist.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            7. Verschiebung / Absage durch uns
          </h2>
          <p>
            (1) Wir sind berechtigt, Termine aus wichtigen Gründen (z. B. Krankheit,
            höhere Gewalt, technische Störungen außerhalb unseres Einflussbereichs)
            zu verschieben oder abzusagen. In diesem Fall wird ein zeitnaher
            Ersatztermin angeboten.
          </p>
          <p>
            (2) Weitergehende Ansprüche, insbesondere Schadensersatz wegen
            ausgefallener Arbeitszeit oder Reisekosten, bestehen nur bei Vorsatz
            oder grober Fahrlässigkeit unsererseits.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            8. Kein Erfolgsversprechen, Verantwortung des Kunden
          </h2>
          <p>
            (1) Unsere Leistungen sind auf Entwicklung, Reflexion, Klarheit und
            Entscheidungsfähigkeit ausgerichtet. Wir geben keine Garantie für
            bestimmte wirtschaftliche oder persönliche Erfolge.
          </p>
          <p>
            (2) Alle Entscheidungen über Strategie, Organisation, Personal und
            sonstige Maßnahmen verbleiben ausschließlich beim Kunden. Der Kunde
            trägt die Verantwortung für Umsetzung, Folgen und Ergebnisse.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            9. Nutzungsrechte an Unterlagen
          </h2>
          <p>
            (1) An von uns erstellten Konzepten, Präsentationen, Modellen,
            Arbeitsunterlagen, Handouts, E-Books und sonstigen Materialien
            erhält der Kunde ein einfaches, nicht übertragbares,
            nicht unterlizenzierbares Nutzungsrecht ausschließlich für eigene
            interne Zwecke.
          </p>
          <p>
            (2) Eine Weitergabe an Dritte, Veröffentlichung, Vervielfältigung
            über den vereinbarten Umfang hinaus oder Nutzung in eigenen
            Trainings-/Beratungsangeboten ist nur mit unserer vorherigen
            schriftlichen Zustimmung zulässig.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            10. Vertraulichkeit
          </h2>
          <p>
            (1) Beide Parteien verpflichten sich zur vertraulichen Behandlung
            aller im Rahmen der Zusammenarbeit bekannt werdenden Informationen,
            die als vertraulich gekennzeichnet sind oder ihrer Natur nach
            vertraulich sind.
          </p>
          <p>
            (2) Die Vertraulichkeitspflicht gilt auch über das Ende der
            Zusammenarbeit hinaus.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            11. Haftung
          </h2>
          <p>
            (1) Wir haften unbeschränkt für Schäden aus der Verletzung des Lebens,
            des Körpers oder der Gesundheit sowie bei Vorsatz und grober
            Fahrlässigkeit.
          </p>
          <p>
            (2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten
            (Kardinalpflichten) ist unsere Haftung auf den vertragstypischen,
            vorhersehbaren Schaden begrenzt.
          </p>
          <p>
            (3) Eine weitergehende Haftung, insbesondere für entgangenen Gewinn,
            mittelbare Schäden oder Folgeschäden, ist ausgeschlossen, sofern
            nicht zwingende gesetzliche Vorschriften entgegenstehen.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            12. Datenschutz
          </h2>
          <p>
            (1) Die Verarbeitung personenbezogener Daten im Rahmen der
            Zusammenarbeit erfolgt gemäß unserer Datenschutzerklärung unter{" "}
            <strong>[URL DATENSCHUTZERKLÄRUNG]</strong>.
          </p>
          <p>
            (2) Der Kunde ist verantwortlich für die Einhaltung datenschutzrechtlicher
            Vorgaben in seinem eigenen Verantwortungsbereich (z. B. Information
            seiner Mitarbeitenden).
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            13. Schlussbestimmungen
          </h2>
          <p>
            (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss
            des UN-Kaufrechts (CISG).
          </p>
          <p>
            (2) Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im
            Zusammenhang mit diesem Vertrag ist, soweit gesetzlich zulässig,{" "}
            <strong>[GERICHTSSTAND, Z. B. FRANKFURT AM MAIN]</strong>.
          </p>
          <p>
            (3) Änderungen und Ergänzungen des Vertrags und dieser AGB bedürfen der
            Textform. Dies gilt auch für die Aufhebung dieses Schriftformerfordernisses.
          </p>
          <p>
            (4) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder
            werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An
            die Stelle der unwirksamen Bestimmung tritt diejenige wirksame Regelung,
            die dem wirtschaftlichen Zweck am nächsten kommt.
          </p>
        </div>
      </section>
    </div>
  );
};
